import React, { forwardRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const StaffIDCard = forwardRef(({ staff, instituteName = "Institute Name" }, ref) => {
  // Generate QR code data
  const qrData = JSON.stringify({
    staff_id: staff.id,
    institute_id: staff.institute_id || 1,
    employee_id: staff.employee_id,
    card_id: `STAFF-${new Date().getFullYear()}-${staff.id}`,
    type: 'staff_attendance',
    issued_date: new Date().toISOString().split('T')[0]
  });

  return (
    <div ref={ref} className="id-card-container" style={{ pageBreakAfter: 'always' }}>
      <div className="id-card bg-white rounded-lg shadow-lg overflow-visible" style={{
        width: '350px',
        minHeight: '600px',
        margin: '20px auto',
        border: '2px solid #e5e7eb',
        fontFamily: 'Arial, sans-serif'
      }}>
        {/* Header */}
        <div className="card-header bg-gradient-to-r from-purple-600 to-purple-800 text-white p-4 text-center">
          <h2 className="text-xl font-bold mb-1">{instituteName}</h2>
          <p className="text-sm opacity-90">Staff ID Card</p>
        </div>

        {/* Photo Section */}
        <div className="card-body p-4">
          <div className="photo-container flex justify-center mb-3">
            {staff.photo ? (
              <img
                src={staff.photo}
                alt={staff.name}
                className="w-32 h-32 rounded-full object-cover border-4 border-purple-200"
              />
            ) : (
              <div className="w-32 h-32 rounded-full bg-purple-100 flex items-center justify-center border-4 border-purple-200">
                <span className="text-4xl font-bold text-purple-600">
                  {staff.name?.charAt(0)}{staff.surname?.charAt(0)}
                </span>
              </div>
            )}
          </div>

          {/* Staff Details */}
          <div className="staff-details text-center mb-3">
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              {staff.name} {staff.surname}
            </h3>
            <p className="text-sm text-purple-600 font-semibold mb-3">
              {staff.role_name || staff.designation || 'Staff Member'}
            </p>
            
            <div className="details-grid text-left bg-gray-50 rounded-lg p-2 mb-3">
              <div className="detail-row flex justify-between py-1 border-b border-gray-200">
                <span className="text-sm font-semibold text-gray-600">Employee ID:</span>
                <span className="text-sm text-gray-900">{staff.employee_id || 'N/A'}</span>
              </div>
              <div className="detail-row flex justify-between py-1 border-b border-gray-200">
                <span className="text-sm font-semibold text-gray-600">Department:</span>
                <span className="text-sm text-gray-900">{staff.department || staff.role_name || 'N/A'}</span>
              </div>
              <div className="detail-row flex justify-between py-1 border-b border-gray-200">
                <span className="text-sm font-semibold text-gray-600">Mobile:</span>
                <span className="text-sm text-gray-900">{staff.mobile || staff.phone || 'N/A'}</span>
              </div>
              <div className="detail-row flex justify-between py-1">
                <span className="text-sm font-semibold text-gray-600">Staff ID:</span>
                <span className="text-sm text-gray-900">{staff.id}</span>
              </div>
            </div>
          </div>

          {/* QR Code */}
          <div className="qr-code-container flex flex-col items-center mb-3">
            <div className="bg-white p-2 rounded-lg border-2 border-gray-300">
              <QRCodeCanvas
                value={qrData}
                size={80}
                level="H"
                includeMargin={true}
              />
            </div>
            <p className="text-xs text-gray-500 mt-2 font-semibold">Scan for Attendance</p>
          </div>
        </div>

        {/* Footer */}
        <div className="card-footer bg-gray-100 p-3 text-center">
          <p className="text-xs text-gray-600">
            Valid: {new Date().getFullYear()}-{new Date().getFullYear() + 1}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            Issued: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
});

StaffIDCard.displayName = 'StaffIDCard';

export default StaffIDCard;
